module.exports = __webpack_public_path__ + "img/lora.0dcbbf35.svg";